import React from 'react'

import { useTranslationContext } from 'stream-chat-react'
import YumEmptyState from '../../../components/YumEmptyState/YumEmptyState'
import { ReactComponent as EmptyStateIcon } from '../../../assets/v3/icons/chat-empty-state.svg'

export type EmptyStateIndicatorProps = {
  /** List Type: channel | message */
  listType?: 'channel' | 'message' | 'thread'
}

const UnMemoizedEmptyStateIndicator = (props: EmptyStateIndicatorProps) => {
  const { listType } = props

  const { t } = useTranslationContext('EmptyStateIndicator')

  if (listType === 'thread') return null

  let text = 'No items exist'

  if (listType === 'channel') {
    text = t('You have no channels currently')
  }

  if (listType === 'message') {
    text = t('No chats here yet…')
  }

  return <YumEmptyState text={text} Icon={EmptyStateIcon} fullHeight={true} />
}

export const EmptyStateIndicator = React.memo(UnMemoizedEmptyStateIndicator) as typeof UnMemoizedEmptyStateIndicator
